import { LABS_SETTINGS_KEY, USER_PREFS_KEY } from '../constants';

export interface TtsPrefs {
  tts: boolean;
  ttsCheckIn: string;
  ttsCheckOut: string;
  notifications: boolean;
  language: string;
}

export function getTtsPrefs(): TtsPrefs {
  try {
    const labs = JSON.parse(localStorage.getItem(LABS_SETTINGS_KEY) ?? '{}') as Record<string, unknown>;
    const prefs = JSON.parse(localStorage.getItem(USER_PREFS_KEY) ?? '{}') as Record<string, unknown>;
    return {
      tts: !!labs.useTTS,
      ttsCheckIn: (labs.ttsCheckIn as string) || 'Bem-vindo! Registro de entrada realizado.',
      ttsCheckOut: (labs.ttsCheckOut as string) || 'Até logo! Registro de saída realizado.',
      notifications: !!prefs.notificationsEnabled,
      language: (prefs.language as string) || 'pt-BR',
    };
  } catch {
    return { tts: false, ttsCheckIn: '', ttsCheckOut: '', notifications: false, language: 'pt-BR' };
  }
}

export function speakTTS(text: string, lang: string): void {
  if (!('speechSynthesis' in window)) return;
  try {
    const utter = new window.SpeechSynthesisUtterance(text);
    utter.lang = lang;
    utter.rate = 1.2;
    utter.volume = 1.0;
    window.speechSynthesis.speak(utter);
  } catch {
    // speechSynthesis unavailable or blocked
  }
}

export function playNotificationSound(): void {
  try {
    const AudioCtx =
      window.AudioContext ??
      (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();
    oscillator.connect(gain);
    gain.connect(ctx.destination);
    oscillator.frequency.setValueAtTime(800, ctx.currentTime);
    oscillator.frequency.setValueAtTime(600, ctx.currentTime + 0.1);
    oscillator.frequency.setValueAtTime(800, ctx.currentTime + 0.2);
    gain.gain.setValueAtTime(0.3, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.3);
    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + 0.3);
  } catch {
    // Audio API unavailable
  }
}
